import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class GroupsAlertsService {

  constructor(private bringozToastService: BringozToastService) {
  }

// CREATE //
  createSuccess() {
    const message = {
      body: 'GROUP_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    const message = {
      body: 'GROUP_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // EDIT //
  editSuccess() {
    const message = {
      body: 'GROUP_EDIT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  editError() {
    const message = {
      body: 'GROUP_EDIT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteSuccess() {
    const message = {
      body: 'GROUP_DELETE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteError() {
    const message = {
      body: 'GROUP_DELETE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  moveBranchesToGroupSuccess() {
    const message = {
      body: 'MOVE_BRANCHES_TO_GROUP_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  moveBranchesToGroupError() {
    const message = {
      body: 'MOVE_BRANCHES_TO_GROUP_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.groups')
  .service('groupsAlertsService', GroupsAlertsService);
